export function routes($stateProvider) {
    $stateProvider
        .state('app.elv.condominios', {
        url: '/condominio',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.elv.condominios.list', {
        url: '/',
        title: 'Gestão de Condomínios',
        template: require('./directory/directory.view.html'),
        controller: 'DirectoryCondominioController',
        controllerAs: 'vm',
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        },
        role: 'elvListarCondominios'
    })
        .state('app.elv.condominios.details', {
        url: '/{id}',
        title: 'Detalhes do Condomínio',
        template: require('./details/details.view.html'),
        controller: 'DetalhesCondominioController',
        controllerAs: 'vm',
        role: 'elvListarCondominios'
    });
}
routes.$inject = ['$stateProvider'];
